import React from 'react';
import PropTypes from 'prop-types';

const SliderMarkSVGR = ({ className }) => (
  <svg
    width='44'
    height='44'
    viewBox='0 0 44 44'
    className={className}
  >
    <defs>
      <mask id='krp0b' width='2' height='2' x='-1' y='-1'>
        <path fill='#fff' d='M6 4h32v32H6z' />
        <path d='M22 36c8.837 0 16-7.163 16-16S30.837 4 22 4 6 11.163 6 20s7.163 16 16 16z' />
      </mask>
      <filter
        id='krp0a'
        width='68'
        height='70'
        x='-12'
        y='-14'
        filterUnits='userSpaceOnUse'
      >
        <feOffset
          dy='2'
          in='SourceGraphic'
          result='FeOffset1033Out'
        />
        <feGaussianBlur
          in='FeOffset1033Out'
          result='FeGaussianBlur1034Out'
          stdDeviation='3.2 3.2'
        />
        <filter
          width='3'
          height='2'
          x='-2'
          y='-1'
          filterUnits='objectBoundingBox'
          id='filter-1'
        >
          <feGaussianBlur stdDeviation='2' in='SourceGraphic' />
        </filter>
      </filter>
      <clipPath id='krp0c'>
        <path
          fill='#fff'
          d='M22 36c8.837 0 16-7.163 16-16S30.837 4 22 4 6 11.163 6 20s7.163 16 16 16z'
        />
      </clipPath>
    </defs>
    <path
      fill='#fff'
      d='M22 32c6.627 0 12-5.373 12-12S28.627 8 22 8s-12 5.373-12 12 5.373 12 12 12z'
    />
    <path fill='#19a683' d='M22 24a4 4 0 100-8 4 4 0 000 8z' />
    <g filter='url(#krp0a)'>
      <path
        fill='none'
        d='M22 36c8.837 0 16-7.163 16-16S30.837 4 22 4 6 11.163 6 20s7.163 16 16 16z'
        mask='url("#krp0b")'
      />
      <path
        fill='#fff'
        fillOpacity='0.2'
        d='M22 36c8.837 0 16-7.163 16-16S30.837 4 22 4 6 11.163 6 20s7.163 16 16 16z'
      />
    </g>
    <path
      fill='none'
      stroke='#003d31'
      strokeMiterlimit='20'
      strokeWidth='8'
      d='M22 36c8.837 0 16-7.163 16-16S30.837 4 22 4 6 11.163 6 20s7.163 16 16 16z'
      clipPath='url("#krp0c")'
    />
    <path d='M24,18 L8,25 L2.79673705,15.0002677 C2.28075975,14.7490764 2,17.4026417 2,16 C2,14.5973583 2.28075975,10.2509236 2.79673705,16.9997323 L18,18 Z' id='Combined-Shape' fill='#19A683' opacity='0.414457775' filter='url(#filter-1)' />
  </svg>
);

SliderMarkSVGR.propTypes = {
  className: PropTypes.string,
};

SliderMarkSVGR.defaultProps = {
  className: '',
};

export default SliderMarkSVGR;
